<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{dialogTitle | translate}}</span>
      <button mat-button class="mat-icon-button"
        (click)="dialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar>

    @if (action === 'new' || action === 'edit') {
      <div>
        <mat-form-field class="example-full-width">
          <input matInput required placeholder="Title" [(ngModel)]="title">
        </mat-form-field>
        <mat-checkbox [(ngModel)]="active">Active</mat-checkbox>
      </div>
    }

    @if (action === 'new' || action === 'edit') {
      <div>
        <quill-editor [(ngModel)]="editorContent">
        </quill-editor>
      </div>
    }
    @if (action === 'show') {
      <div class="preview">
        <quill-editor [(ngModel)]="html" [readOnly]="true" [modules]="{toolbar:false}" [style]="{border: '0px'}"></quill-editor>
      </div>
    }

  </div>

  <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">

    @if (action ==='new') {
      <button
        mat-raised-button
        (click)="dialogRef.close({html: editorContent, title: title, active: active})"
        class="save-button mat-accent"
        [disabled]="!editorContent || !title"
        aria-label="SAVE">
        SAVE
      </button>
    }

    @if (action ==='edit') {
      <button
        mat-raised-button
        (click)="dialogRef.close(['save', {html: editorContent, title: title, active: active}])"
        class="save-button mat-accent"
        aria-label="SAVE">
        {{'main.save' | translate}}
      </button>
    }

    @if (action ==='edit') {
      <button
        mat-button
        class="mat-icon-button"
        (click)="dialogRef.close(['delete'])"
        aria-label="Delete"
        matTooltip="Delete">
        <mat-icon>delete</mat-icon>
      </button>
    }

  </div>
</div>
